import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { StoreType } from "../../../../core/store/reducers";
import { FetchStateType } from "../../../models";
import { deleteProductGroup } from "../thunks/deleteProductGroup";
import { setFetchState } from "../productGroupDataReducer";

export const useProductGroupDelete = () => {
	const fetchState = useSelector<StoreType, FetchStateType>(
		store => store.data.listing.productGroups.fetchState
	);

	const dispatch = useDispatch();
	const dispatchDeleteRole = React.useCallback(
		(id: string) => dispatch(deleteProductGroup(id)),
		[dispatch]
	);

	React.useEffect(() => {
		dispatch(setFetchState({ type: "not-started" }))
	}, [dispatch])

	return [fetchState, dispatchDeleteRole] as [typeof fetchState, typeof dispatchDeleteRole]
};
